import axios from "axios";

export default function EntrylogCountByZoneService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/entry_log/count_by_zone",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
